module.exports = __webpack_public_path__ + "static/media/imagem23.5f9ff055.jpeg";